<template>
  <ns-toast
    icon
    :warning="warning"
    :success="success"
    :message="message"
    :show-trigger="trigger"
    :cta-button="buttonText"
    :on-cta-click="buttonClick"
  />
</template>

<script>
import {
  events,
} from '@nuskin/ns-util'

import {
  NsToast
} from '@nuskin/design-components'

export default {
  components: {
    NsToast
  },
  props: {
    warning: {
      type: Object,
      default: undefined
    },
    success: {
      type: Object,
      default: undefined
    },
    message: String,
    event: String,
    buttonText: String,
    buttonClickUrl: String
  },
  data() {
    return {
      trigger: 'trigger' // the value of this prop is not important. It just notifies the toast to update
    }
  },
  methods: {
    buttonClick: function() {
      window.open(this.buttonClickUrl, '_self')
    }
  },
  mounted() {
    events.subscribe(this.event, () => {
      this.trigger = !this.trigger
    })
  }
}
</script>
<style lang="scss" scoped>

</style>
